import { render } from "./VehicleTripsSummary.vue?vue&type=template&id=72ac1b8d"
import script from "./VehicleTripsSummary.vue?vue&type=script&lang=js"
export * from "./VehicleTripsSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__